<svg width="100%" viewBox="-5 -5 120 120">

  <g>
    <circle cx="55" cy="55" r="55" fill="#fff" stroke-width="10" stroke="#fff" />
  </g>

  <g>
    <circle cx="55" cy="55" r="48" fill="#fff" stroke-width="8" stroke="#DBDDDD" />
  </g>

  <g [attr.style]="resetOffSet()">
    <circle cx="55" cy="55" r="48" fill="#fff" stroke-width="8" [attr.stroke-dasharray]="strokeDashArray(centerText,48)"
      [attr.stroke-dashoffset]="strokeDashOffSet(centerText, true)" stroke="#9B59B6" />
  </g>


  <g class="text-graph" *ngIf="centerText">
    <text text-anchor="middle" x="55" y="60">
      <tspan class="centerPercent" x="58" y="65">{{getRoundNumber(centerText)}}%</tspan>
    </text>
  </g>


</svg>